var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"administrator",attrs:{"flat":""}},[_c('account-settings',{attrs:{"accountData":_vm.student,"onClick":_vm.resetPassword,"onClicked":_vm.deleteUser}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }